export const itemTrackerHeaders = {
  OrderNumber1: {
    name: "Order No",
    width: 0.2,
    isSort: true,
    sortDirection: "asc",
  },
  ItemCode: {
    name: "Item Code",
    width: 0.3,
  },
  ItemName: {
    name: "Item Name",
    width: 0.6,
  },
  BPName: {
    name: "Customer Name",
    width: 0.6,
  },
  OrderDate: {
    name: "Order Date",
    width: 0.2,
    sortDirection: "asc",
  },
  RequestDate: {
    name: "Request Date",
    width: 0.25,
  },
  ReadyByDate: {
    name: "Ready By Date",
    width: 0.2,
    sortDirection: "asc",
  },
  TotalOrdered: {
    name: "Order Qty",
    width: 0.3,
    textAlign: "center",
  },
  // Salesperson: {
  //   name: "Sales",
  //   width: 0.25,
  // },
  // LeadTimeGivenW: {
  //   name: "Lead Time",
  //   width: 0.15,
  // },
  progress: {
    name: "Progress",
    width: 0.2,
    // textAlign: "center",
    // justifyContent: "center",
  },
  DaysLeft: {
    name: "Days Left",
    width: 0.15,
  },
  // StateDelivery: {
  //   name: "Location",
  //   width: 0.2,
  // },
  // delivery: {
  //   name: "Delivery",
  //   width: 0.2,
  // },
  OrderStatus: {
    name: "Order Status",
    width: 0.3,
    textAlign: "left",
  },
  trackerActions: {
    name: "Actions",
    width: 0.2,
    textAlign: "center",
  },
};

export const mdItemTrackerHeaders = {
  OrderNumber1: {
    name: "Order No",
    width: 0.2,
    isSort: true,
    sortDirection: "asc",
  },
  ItemCode: {
    name: "Item Code",
    width: 0.5,
  },
  BPName: {
    name: "Customer Name",
    width: 1.4,
  },
  TotalOrdered: {
    name: "Order Qty",
    width: 0.3,
  },
  OrderDate: {
    name: "Order Date",
    width: 0.3,
  },
  progress: {
    name: "Progress",
    width: 0.4,
  },
  StateDelivery: {
    name: "Location",
    width: 0.3,
  },
  OrderStatus: {
    name: "Order Status",
    width: 0.25,
    textAlign: "left",
  },
  trackerActions: {
    name: "Actions",
    width: 0.4,
    textAlign: "right",
    justifyContent: "center",
  },
};

export const smItemTrackerHeaders = {
  OrderNumber1: {
    name: "Order No",
    width: 0.3,
    isSort: true,
    sortDirection: "desc",
  },
  ItemCode: {
    name: "Item Code",
    width: 0.5,
  },
  OrderStatus: {
    name: "Order Status",
    width: 0.4,
  },
  trackerActions_sm: {
    name: "Actions",
    width: 0.4,
    textAlign: "center",
    justifyContent: "center",
  },
};
